/*
  Purida – Produktseite (Redesign 09/2026)

  1. Lieferdatum im Kasten unter „Auf Lager“ ([data-pd-dlv], nur Deutschland).
     Gleiche Regel wie der Lieferhinweis im Warenkorb (Theme-Einstellungen 2–4 Tage, Annahmeschluss 13 Uhr,
     ohne Sa/So): Bestellung bis 13 Uhr = heute + 2–4 Werktage, danach + 3–5. Zusätzlich zählen die
     Feiertage unten nicht. Nach 13 Uhr und am Wochenende sagt eine zweite Zeile, wann das Paket rausgeht.

  2. „Ähnliche …“ und „Sofort lieferbar und ähnlich“ ([data-pd-similar]).
     Holt lieferbare Treffer über die Shop-Suche (/search?…&section_id=purida-aehnliche). Suchbegriffe kommen
     aus dem Produkttitel (die letzten zwei Wörter, dann das letzte Wort, dann die Produktart). Übernommen
     werden nur Produkte derselben Produktart oder mit genau diesem Begriff im Titel, nie das Produkt selbst
     und nichts, was schon auf der Seite steht.

  3. Kaufleiste beim Scrollen: misst ihre Höhe in --pd-sticky-h und setzt html.pd-sticky-on, damit Newsletter-Hinweis
     (.popup-minimal) und Chat-Knopf (VanChat) darüber bleiben statt den Kaufen-Knopf zu verdecken (CSS in purida-product.css).
*/
(function () {
  'use strict';

  /* ---------- 1. Lieferdatum ---------- */

  // Bundesweite Feiertage und Niedersachsen (Lager Harsefeld): kein Versand, keine Zustellung
  var HOLIDAYS = [
    '2026-10-03', '2026-10-31', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17',
    '2027-10-03', '2027-10-31', '2027-12-25', '2027-12-26'
  ];
  var CUTOFF = 13 * 60;
  var DAY_SHORT = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var DAY_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function isoDay(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function isWorkday(d) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(isoDay(d)) === -1;
  }
  function addWorkdays(d, n) {
    var x = new Date(d.getTime());
    var c = 0;
    while (c < n) {
      x.setUTCDate(x.getUTCDate() + 1);
      if (isWorkday(x)) c++;
    }
    return x;
  }
  function fmt(d) { return DAY_SHORT[d.getUTCDay()] + ', ' + pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.'; }

  function berlinNow() {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    } catch (e) {
      return null;
    }
    if (!o.year) return null;
    return {
      day: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)),
      minutes: (+o.hour % 24) * 60 + (+o.minute)
    };
  }

  function updateDelivery() {
    var boxes = document.querySelectorAll('[data-pd-dlv]');
    if (!boxes.length) return;
    var now = berlinNow();
    if (!now) return;
    var today = now.day;
    var late = now.minutes > CUTOFF;
    var extra = late ? 1 : 0;
    var from = addWorkdays(today, 2 + extra);
    var to = addWorkdays(today, 4 + extra);
    var dateText = 'Lieferung voraussichtlich ' + fmt(from) + ' – ' + fmt(to);

    var shipText = '';
    if (!isWorkday(today) || late) {
      var ship = addWorkdays(today, 1);
      var tomorrow = new Date(today.getTime());
      tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      shipText = isoDay(ship) === isoDay(tomorrow)
        ? 'Bestellst du jetzt, geht dein Paket morgen raus.'
        : 'Bestellst du jetzt, geht dein Paket am ' + DAY_LONG[ship.getUTCDay()] + ' raus.';
    }

    Array.prototype.forEach.call(boxes, function (box) {
      var date = box.querySelector('[data-pd-dlv-date]');
      var ship = box.querySelector('[data-pd-dlv-ship]');
      if (date) date.textContent = dateText;
      if (ship) {
        ship.textContent = shipText;
        ship.hidden = !shipText;
      }
    });
  }

  /* ---------- 2. Ähnliche Produkte ---------- */

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NOISE = /^(set|kit|duo|trio|mini|jumbo|refill|edition|limited|travel|special|pack|er|x|ml|g|kg|l|ea|st|stk|stück|pcs|pads?|patches|sheets?|pairs?|spf\d*|lsf\d*|pa|and|with|mit|und|für|the|for|of|in)$/i;

  function searchTerms(title, vendor, type) {
    var t = title || '';
    if (vendor && t.toLowerCase().indexOf(vendor.toLowerCase()) === 0) t = t.slice(vendor.length);
    t = t.split(/\s[-–—|]\s|:/)[0];
    t = t.replace(/\([^)]*\)/g, ' ')
      .replace(/\d+([.,]\d+)?\s*(ml|g|kg|l|ea|st|stk|stück|pcs|er)(?![a-zäöüß])\.?/gi, ' ');
    var words = t.split(/[\s+&,\/]+/)
      .map(function (w) { return w.replace(/^[^0-9A-Za-zÄÖÜäöüß]+|[^0-9A-Za-zÄÖÜäöüß]+$/g, ''); })
      .filter(function (w) { return w.length > 1 && !/^\d+%?$/.test(w) && !NOISE.test(w); });
    var terms = [];
    if (words.length >= 2) terms.push({ q: words.slice(-2).join(' '), phrase: true });
    var last = words[words.length - 1];
    if (last && last.length >= 4) terms.push({ q: last, phrase: false });
    if (type) terms.push({ q: type, phrase: false });
    return terms;
  }

  function searchUrl(q, hideSoldOut, sectionId) {
    var url = ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last' +
      '&options%5Bunavailable_products%5D=' + (hideSoldOut ? 'hide' : 'last');
    if (sectionId) url += '&section_id=' + sectionId;
    return url;
  }

  function loadSimilar(box) {
    if (box.getAttribute('data-pd-loaded')) return;
    box.setAttribute('data-pd-loaded', '1');
    var list = box.querySelector('[data-pd-similar-list]');
    if (!list || !window.fetch || !window.DOMParser) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 4;
    var type = (box.getAttribute('data-type') || '').trim();
    var terms = searchTerms(box.getAttribute('data-title'), box.getAttribute('data-vendor'), type);
    if (!terms.length) return;

    var seen = {};
    seen[box.getAttribute('data-handle')] = true;
    Array.prototype.forEach.call(document.querySelectorAll('[data-pd-item]'), function (el) {
      seen[el.getAttribute('data-handle')] = true;
    });

    var picked = [];
    var more = box.querySelector('[data-pd-similar-more]');
    if (more) more.href = searchUrl(terms[0].q, false);

    function next(i) {
      if (picked.length >= limit || i >= terms.length) return finish();
      var term = terms[i];
      fetch(searchUrl(term.q, true, 'purida-aehnliche'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var phrase = term.q.toLowerCase();
            Array.prototype.forEach.call(doc.querySelectorAll('[data-pd-item]'), function (el) {
              if (picked.length >= limit) return;
              var handle = el.getAttribute('data-handle');
              if (!handle || seen[handle]) return;
              var sameType = type && el.getAttribute('data-type') === type;
              var name = (el.querySelector('.pd-item__name') || el).textContent.toLowerCase();
              if (!sameType && !(term.phrase && name.indexOf(phrase) !== -1)) return;
              seen[handle] = true;
              picked.push(el);
            });
          }
          next(i + 1);
        })
        .catch(function () { next(i + 1); });
    }

    function finish() {
      if (!picked.length) return;
      picked.forEach(function (el) { list.appendChild(document.importNode(el, true)); });
      box.hidden = false;
    }

    next(0);
  }

  function initSimilar() {
    var boxes = document.querySelectorAll('[data-pd-similar]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.hasAttribute('data-lazy') && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              loadSimilar(box);
            }
          });
        }, { rootMargin: '600px 0px' });
        // Der Kasten ist bis zum Laden versteckt, beobachtet wird deshalb die Section drumherum
        io.observe(box.parentElement || box);
      } else {
        loadSimilar(box);
      }
    });
  }

  /* ---------- 3. Kaufleiste: Höhe für den Abstand von Newsletter-Hinweis und Chat-Knopf ---------- */

  function watchStickyBar() {
    var bar = document.querySelector('.sticky_add_to_cart');
    if (!bar) return;
    var root = document.documentElement;
    function update() {
      var shown = getComputedStyle(bar).display !== 'none';
      var h = shown ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      root.style.setProperty('--pd-sticky-h', h + 'px');
      root.classList.toggle('pd-sticky-on', h > 0);
    }
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(bar);
    if ('MutationObserver' in window) new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
    update();
  }

  function init() {
    updateDelivery();
    setInterval(updateDelivery, 60000);
    initSimilar();
    watchStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
